<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Notivue, Notification } from 'notivue';

const route = useRoute();

const layout = computed(() => {
  return route.meta.layout || 'div';
});
</script>

<template>
  <component :is="layout">
    <router-view />
  </component>
  <Notivue v-slot="item">
    <Notification :item="item" />
  </Notivue>
</template>

<style scoped></style>
